import { render } from "./ObInput.vue?vue&type=template&id=0fb11d9f&scoped=true"
import script from "./ObInput.vue?vue&type=script&lang=js"
export * from "./ObInput.vue?vue&type=script&lang=js"

import "./ObInput.vue?vue&type=style&index=0&id=0fb11d9f&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb11d9f"]])

export default __exports__